<script>
  import { onMount } from "svelte";
  import Header from "../../views/Header.svelte";

  let visible = false;

  onMount(() => {
    setTimeout(() => {
      visible = true;
    }, 50);
  });
</script>

<style lang="scss">
  .headline {
    display: flex;
    flex-direction: column;
    padding: 0 15em;
    opacity: 1;
    background: transparent url('../assets/main-headline-bg-2.png') 0% 0% no-repeat padding-box;
    background-size: contain;
    height: 50em;

    visibility: hidden;
    opacity: 0;

    &.visible {
      transition: opacity 0.1s;
      visibility: visible;
      opacity: 1;
    }

    .headline__article {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      img {
        width: 550px;
        margin-right: 2em;
      }
      .headline__text {
        width: 35em;

        h3 {
          margin: 0;
        }

        p {
          font-size: 25px;
          letter-spacing: 0;
          line-height: 43px;
          width: 25em;
        }
      }
    }
  }
</style>

<section class="headline" class:visible={visible}>
  <Header />
  <article class="headline__article">
    <figure><img src="assets/app-screens.png" alt="Mobile app screens"></figure>
    <section class="headline__text">
      <h3 class="header-title wc">Next level energy insights</h3>
      <p class="wc">Octopus and Voltaware have joined forces<br/>to help you optimise your energy use</p>
      <p class="wc"><strong>Order now - limited quantities!</strong></p>
    </section>
  </article>
</section>
